import React, { useState, useEffect } from 'react';
import {
  Card, CardContent, Typography, Grid, Box, TextField, Button, Paper, Badge, Avatar,
  InputAdornment, ListItem, Divider, Dialog, DialogTitle,
  DialogContent, DialogActions, IconButton, MenuItem
} from '@mui/material';

import { Checkbox, FormControlLabel,Stack } from "@mui/material";

import { Assignment, Build, CheckCircle, Close, Search } from '@mui/icons-material';


import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { TfiReload } from "react-icons/tfi";

import DashboardIcon from '@mui/icons-material/Dashboard';														  
import { UploadOutlined } from '@ant-design/icons';
import { Button as Btn, Upload, message,Radio,Input } from 'antd';
import axios from 'axios';
import Swal from 'sweetalert2';
import { formatDistanceToNow } from 'date-fns';
import SendIcon from '@mui/icons-material/Send';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Backdrop, CircularProgress, } from '@mui/material';
import { BASE_URL } from "../../App";
import  PicChartCalls  from "./pie_chart";
import  SalesPicChartCalls  from "./sales_chart";
import  Service_Bar_Chart  from "./Service_Bar_Chart";
import  Service_Bar_Chart_New  from "./Service_Bar_Chart_new";

import SearchIcon from '@mui/icons-material/Search';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import InfoIcon from '@mui/icons-material/Info';

const styles = {
  navbarContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '8px',
    overflowX: 'auto',
  },
  navbarContainerXs: {
    minHeight: '300px',
    maxHeight: '80vh',
  },
  listItem: {
    flex: '0 0 auto',
    width: '100%',
    marginBottom: '16px',
    minWidth: '250px',
    maxWidth: '400px',
    marginBottom: '8px',
    
  },
};
const StockView = () => {
	
	const [RadioValue, setRadioValue] = useState(0);
	const [SearchInput, setSearchInput] = useState(null);
	const [FieldPartnerValue, setFieldPartnerValue] = useState(null);
  const [openCompletedDialog, setOpenCompletedDialog] = useState(false);
 const [dashboard, setDashboard] = useState(false);
  const [dashboardview, setdashboardview] = useState(0);													
  const [visibleItems, setVisibleItems] = useState(5);
  const [salesList, setSalesList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openSalesDialog, setOpenSalesDialog] = useState(false);
  const [activeList, setActiveList] = useState('');
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth <= 600);
  const [serviceList, setserviceList] = useState([]);
	 const [dashboardList, setdashboardList] = useState([]);													 
  const [CommentDatasales, setCommentDatasales] = useState([]);
  const [CommentDataservice, setCommentDataservice] = useState([]);
  const [comment, setComment] = useState('');
  const login_id = localStorage.getItem("LOGIN_ID");
  const USER_ID = localStorage.getItem("USER_ID");
  const [callStatus, setCallStatus] = useState('');
  const [closureComments, setClosureComments] = useState('');
  const [productValue, setProductValue] = useState('');
  const [itemName, setItemName] = useState('');
  const [serialNo, setSerialNo] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState('');
  const [isEditing1, setIsEditing1] = useState(false);
  const [show, setshow] = useState(false);
  const [currentMechanic, setCurrentMechanic] = useState('');
  const [selectedMechanic, setSelectedMechanic] = useState('');
  const [mechanicList, setMechanicList] = useState([]);
  const [openServiceDialog, setOpenServiceDialog] = useState(false);
  const [callStatusComment, setCallStatusComment] = useState('');
  const [serviceStatusList, setServiceStatusList] = useState([]);
  
  const [outOfWarranty, setOutOfWarranty] = useState([]);
  const [outOfWarrantycheck, setOutOfWarrantycheck] = useState(false);
  
  const [serviceDetails, setServiceDetails] = useState({});
  const [customerDetails, setCustomerDetails] = useState({});
  const [showHappyCode, setShowHappyCode] = useState(true);
  const [selectedStatusId, setSelectedStatusId] = useState('');
  const [hpy_code, setHappyCode] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [loading, setloading] = React.useState(false);
  const [loading1, setloading1] = React.useState(false);
  const handleChangehappy = (event) => {
    setHappyCode(event.target.value);
  };
  
      const [pumpmotorimage , setPumpmotorimage]=useState(false);
	  const [serialNoImage, setSerialNoImage] = useState([]);
	  const [motorComponentImage, setMotorComponentImage] = useState([]);
	  const [pumpComponentImage1, setPumpComponentImage1] = useState([]);
	  const [pumpComponentImage2, setPumpComponentImage2] = useState([]);
  
	const [InputTokenNo, setInputTokenNo] = useState(null);
    const [TokenDetails, setTokenDetails] = useState([]);
    const [TokenType, setTokenType] = useState(null);
	
	const [refferedReplascement , setRefferedReplascement] = useState(false);
    const [refferenceNumber , setRefferenceNumber] = useState('');


  const [dealerAndSubDealer ,setDealerAndSubDealer] = useState(null);
  const [dealerAndSubDealerList ,setDealerAndSubDealerList] = useState([]);
  const [dealerAndSubDealerSearchList, setDealerAndSubDealerSearchList] = useState(null);
	
	
	useEffect(() => {
		setInputTokenNo(null);
	}, [activeList]);
	
	const ViewBtnClick = () => {
        setloading1(true);
        const data = {
            TokenNo: InputTokenNo,
            MAINCODE: login_id,
        }

        axios.post(BASE_URL + '/TokenNoDetails', data,
        ).then(response => {
            setTokenDetails(response.data.data[0]);
            setTokenType(response.data.type);
        }).catch(error => {
            Swal.fire({
                icon: "warning",
                text: error.response.data.Message
            });
            setTokenDetails([]);
        }).finally(() => {
            setloading1(false);
        });
    };
  
  
  const handleEditClick1 = () => setIsEditing1(true);

  const handleCancelClick1 = () => {
    setSelectedMechanic(currentMechanic);
    setIsEditing1(false);
  };
  const handleEditClick = () => setIsEditing(true);
  const handleCancelClick = () => setIsEditing(false);
  const isFormValid = () => {
    return productValue.trim() !== '' && itemName.trim() !== '' && serialNo.trim() !== '';
  };
  const handleButtonClick = () => {
    window.open('https://mobile.cri.in/others/productregistration/#/', '_blank');
  };
  const [UploadInvImg, setUploadInvImg] = useState([])
  const acceptedFileTypes = ['image/jpeg', 'image/png'];
  const InvoiceImage = {
    onRemove: (file) => {
      setUploadInvImg([]);
      const index = UploadInvImg.indexOf(file);
      const newFileList = UploadInvImg.slice();
      newFileList.splice(index, 1);
      setUploadInvImg(newFileList);
    },
    beforeUpload: (file) => {
      setUploadInvImg([]);
      const index = UploadInvImg.indexOf(file);
      const newFileList = UploadInvImg.slice();
      newFileList.splice(index, 1);
      setUploadInvImg(newFileList);

      const isAcceptedFileType = acceptedFileTypes.includes(file.type);
      if (!isAcceptedFileType) {
        message.error('You can only upload JPEG and PNG image files!');
      } else {
        setUploadInvImg([file]);
      }
      return false;
    },
    UploadInvImg,
  };


  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} {...props} />;
  });


  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };
  useEffect(() => {
    SalesLISTAPI();
    ServiceLISTAPI();
    const handleResize = () => {
      setIsXsScreen(window.innerWidth <= 600);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  const SalesLISTAPI = async () => {

    try {
      setloading1(true);
      const response = await axios.post(BASE_URL + '/tollfreependingsales', {
        login_id: login_id
      });

      setSalesList(response.data.tollfreependingsalessaleslist);
      setloading1(false);
    } catch (error) {
      setloading1(false);
      console.error('Error fetching data:', error);
    }
  };
  const ServiceLISTAPI = async () => {

    try {
      setloading1(true);
      const response = await axios.post(BASE_URL + '/tollfreependingservice', {
        login_id: login_id,
        RadioValue: RadioValue,
        linecount: 'ALL'
      });
      setserviceList(response.data.tollfreependingservicelist);
      setloading1(false);
    } catch (error) {
      setloading1(false);
      console.error('Error fetching data:', error);
    }
  };


  const fetchCommentData = async (tokenno) => {

    try {
      setloading1(true);
      const commentsResponse = await axios.post(BASE_URL + '/tollfreegetsalescomments', {
        login_id: login_id,
        token_no: tokenno
      });
      const comments = commentsResponse.data.tollfreecomments || [];
      if (comments.length > 0) {

        setCommentDatasales(comments);
        setloading1(false);
      } else {
        setloading1(false);
        setCommentDatasales([]);
      }
    } catch (error) {
      setloading1(false);
      console.error('Error fetching comment data:', error);
    }
  };
  const fetchCommentData1 = async (tokenno) => {
    try {
      setloading1(true);
      const commentsResponse = await axios.post(BASE_URL + '/tollfreegetservicecomments', {
        login_id: login_id,
        token_no: tokenno
      });
      const comments = commentsResponse.data.tollfreecomments || [];
      if (comments.length > 0) {

        setCommentDataservice(comments);
        setloading1(false);
      } else {
        setloading1(false);
        setCommentDataservice([]);
      }
    } catch (error) {
      setloading1(false);
      console.error('Error fetching comment data:', error);
    }
  };
  const openItemDialogsalesAPI = async (tokenno) => {
    try {
      setloading1(true);
      const response = await axios.post(BASE_URL + '/tollfreegetsalestokennodetails', {
        login_id: login_id,
        token_no: tokenno
      });

      if (response.data && response.data.tollfreesalesdetails && response.data.tollfreecustomerdetails) {
        const salesDetails = response.data.tollfreesalesdetails[0];
        const customerDetails = response.data.tollfreecustomerdetails[0];

        setSelectedItem({
          tokenno: salesDetails.tokenno,
          hp: salesDetails.Hp,
          application: salesDetails.application,
          product: salesDetails.product,
          comment: salesDetails.comment,
          cust_comment: salesDetails.cust_comment,
          custid: salesDetails.custid,
          name: customerDetails.name,
          address: customerDetails.c_address,
          pincode: customerDetails.pincode,
          mobileno: customerDetails.mobileno,
          status: salesDetails.status
        });
        setloading1(false);
        setOpenSalesDialog(true);

      } else {
        setloading1(false);
        console.error('Invalid data format in API response:', response);
      }
    } catch (error) {
      setloading1(false);
      console.error('Error fetching data:', error);
    }
  };

  const handleSearch = () => {

      console.log('Searching for:', dealerAndSubDealerSearchList);

      if (dealerAndSubDealerSearchList == null || dealerAndSubDealerSearchList.trim() == '') {
        Swal.fire({
          icon: 'warning',
          title: 'Warning',
          text: 'Please enter a search place.',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              swalContainer.style.zIndex = 99999; // make it appear on top of all modals
            }
          },
        });
        return;
      }

    axios.post(BASE_URL + '/tollfreeDealerAndSubDealerSearchList',{ dealer_and_subdealer: dealerAndSubDealerSearchList}).then((response) => {
        const data = response.data.data || [];

      const filteredList = dealerAndSubDealerList.filter((item) =>
        data.some((d) => d.code === item.code)
      );

      console.log('Filtered + Matched List:', filteredList);

      // Show only the matched list in Typeahead
      setDealerAndSubDealerList(filteredList);

      }).catch((err) => {
        Swal.fire('Error', err.data.message, 'error');
      });
    };


  const handleCallStatusChangeService = async (event) => {
    const selectedValue = event.target.value;
    setCallStatusComment(selectedValue);
    const selectedStatus = serviceStatusList.find(status => status.remarks === selectedValue);
    const selectedRemark = event.target.value;
    setCallStatusComment(selectedRemark);

    const selectedStatus1 = serviceStatusList.find(status => status.remarks === selectedRemark);
    setSelectedStatusId(selectedStatus1 ? selectedStatus1.id : '');
    if (selectedValue === '' || selectedValue === '1' || (selectedStatus && Number(selectedStatus.status_id) === 1)) {
      setShowHappyCode(false);
    } else {
      setShowHappyCode(true);
    }
	
	setRefferenceNumber('');
  setDealerAndSubDealerList([]);
	
	if(selectedValue == "ATTENDED AT FIELD AND RESOLVED"){
      setPumpmotorimage(true);
	  setRefferedReplascement(false);
    } else if(selectedValue == "REFERRED FOR REPLACEMENT"){
      setRefferedReplascement(true);
 
        await axios.get(BASE_URL + '/tollfreeRefferedforreplacement').then((response) =>{
           setRefferenceNumber(response.data.data);
        }).catch((err) =>{
          Swal.fire('Error', err.data.message, 'error');
        });

       await axios.get(BASE_URL + '/tollfreeDealerAndSubDealerList').then((response) =>{
          
            setDealerAndSubDealerList(response.data.data);
        }).catch((err) =>{
          Swal.fire('Error', err.data.message, 'error');
        });

    } else {
      setPumpmotorimage(false);
	  setRefferedReplascement(false);
      setSerialNoImage([]);
      setMotorComponentImage([]);
      setPumpComponentImage1([]);
      setPumpComponentImage2([]);
    }
	
  };

  const options = dealerAndSubDealerList.map((item) => ({
  value: item.code,
  label: `${item.code} - ${item.name}`,
}));


const reloadeDealerAndSubDealerList = async () => {
    try {
      setloading1(true);
      await axios.get(BASE_URL + '/tollfreeDealerAndSubDealerList').then((response) =>{
          
            setDealerAndSubDealerList(response.data.data);
        }).catch((err) =>{
          Swal.fire('Error', err.data.message, 'error');
        });
        setloading1(false);
    } catch (error) {
      setloading1(false);
      console.error('Error fetching data:', error);
    }
  };

  const handle_area_district_state_pincode_change = () => (event) => {

    if (event.target.value.length > 0) {
      setDealerAndSubDealerSearchList(event.target.value);
    } else {
      setDealerAndSubDealerSearchList(null);
      reloadeDealerAndSubDealerList();
    }

  };

  const openItemDialogserviceAPI = async (tokenno) => {
    try {
      setloading1(true);
      const response = await axios.post(BASE_URL + '/tollfreegetservicetokennodetails', {
        login_id,
        token_no: tokenno
      });

      if (response.data) {
        const {
          tollfreeservicedetails = [],
          tollfreecustomerdetails = [],
          assignedmechanic = [],
          mechaniclist = [],
          servicestatuslist = [],
		  warranty_count =[]
        } = response.data;

        setServiceDetails(tollfreeservicedetails[0] || {});
        setCustomerDetails(tollfreecustomerdetails[0] || {});
        setCurrentMechanic(assignedmechanic.length > 0 ? assignedmechanic[0].mech_name : 'Mechanic Not Assigned');
        setMechanicList(mechaniclist || []);
        setSelectedMechanic(assignedmechanic.length > 0 ? assignedmechanic[0].mech_name : '');

        setServiceStatusList(servicestatuslist || []);
        setOutOfWarranty(warranty_count[0]);

        const hasStatusIdOne = servicestatuslist.some(status => Number(status.status_id) === 1);
        setShowHappyCode(!hasStatusIdOne);

        setOpenServiceDialog(true);
        setloading1(false);
      } else {
        setloading1(false);
        console.error('Invalid data format in API response:', response.data);
      }
    } catch (error) {
      setloading1(false);
      console.error('Error fetching data:', error);
    }
  };


  const handleListItemClick = (tokenno) => {
    openItemDialogsalesAPI(tokenno);
    openItemDialogserviceAPI(tokenno);
    fetchCommentData(tokenno);
    fetchCommentData1(tokenno);

  };

  const handleChangeComment = (event) => {
    setComment(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      setloading(true);
      const response = await axios.post(BASE_URL + '/tollfreeupdatesalescomments', {
        login_id: login_id,
        token_no: selectedItem.tokenno,
        comments: comment,

      });
      // Assuming successful response is indicated by the HTTP status code 200
      if (response.status === 200) {
        setloading(false);

        setComment('');
        fetchCommentData(selectedItem.tokenno);
      } else {
        setloading(false);

        // Show eror if the response is not successful
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Unexpected error occurred. Please try again later.',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
        }).then(() => {
          setOpenServiceDialog(true);
        });
      }

    } catch (error) {
      setloading(false);

      console.error('Error submitting comments:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Please try again later.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then(() => {
        setOpenServiceDialog(true);
      });
    }
  };
  const handleChange = (e) => {

    setServiceDetails({
      ...serviceDetails,
      serialno: e.target.value,
    });
  };

  const handleCallStatusChangeSales = (event) => {
    setCallStatus(event.target.value);
  };

  const handleClosureCommentsChange = (event) => {
    setClosureComments(event.target.value);
  };
  const handleStatusSubmit = async () => {
    try {

      setloading(true);
      const response = await axios.post(BASE_URL + '/tollfreeupdatesalesstatus', {
        login_id: login_id,
        token_no: selectedItem.tokenno,
        call_status: callStatus,
        closure_comments: closureComments,
        serial_no: serialNo,
        product_value: productValue,
        item_name: itemName
      });


      const { success, message, code } = response.data;

      if (message) {
        setloading(false);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: message,
          showConfirmButton: false,
          timer: 1500,
        });


        setOpenSalesDialog(false);

        SalesLISTAPI();
        setComment('');
      } else {
        setloading(false);
        setOpenSalesDialog(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: message || 'Please try again later.',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
        }).then(() => {
          setOpenSalesDialog(true);
        });
      }
    } catch (error) {
      setloading(false);
      console.error('Error submitting comments:', error);


      setOpenSalesDialog(false);


      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Please try again later.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then(() => {
        setOpenSalesDialog(true);
      });
    }
  };




  const handleUpdateClick = async () => {
    try {
      setloading(true);

      const response = await axios.post(BASE_URL + '/updateserialnoservice', {
        login_id: login_id,
        token_no: serviceDetails.tokenno,
        serialno: serviceDetails.serialno
      });

      const message = response.data.message;
      setloading(false);

      setSnackbarMessage(message);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);

      setIsEditing(false);
      // setOpenServiceDialog(false);

    } catch (error) {
      setloading(false);

      console.error('Error updating serial number:', error);
      //setOpenSalesDialog(false);

      setSnackbarMessage('There was an error updating the serial number.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);

      //setOpenSalesDialog(true);
    }
  };

  const handleUpdateClick1 = async () => {
    try {
      setloading(true);

      const selectedMechanicname = mechanicList.find(
        (mechanic) => mechanic.mech_name === selectedMechanic
      )?.mobile_number;

      const response = await axios.post(BASE_URL + '/updatemechanicservice',
        {
          login_id,
          token_no: serviceDetails.tokenno,
          mechanic_id: selectedMechanicname,
        }
      );

      const message = response.data.message;
      setloading(false);

      setSnackbarMessage(message);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);

      setCurrentMechanic(selectedMechanic);
      setIsEditing1(false);
    } catch (error) {
      setloading(false);

      console.error('Error updating mechanic:', error);

      setSnackbarMessage('There was an error updating the mechanic.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };


  const handleServiceSubmit = async () => {
    try {
      setloading(true);

      const response = await axios.post(BASE_URL + '/tollfreeupdateservicecomments', {
        login_id: login_id,
        token_no: serviceDetails.tokenno,
        comments: comment,
      });

      // Assuming successful response is indicated by the HTTP status code 200
      if (response.status === 200) {
        setloading(false);

        setComment('');
        fetchCommentData1(serviceDetails.tokenno);

      } else {
        setloading(false);

        // Show eror if the response is not successful
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Unexpected error occurred. Please try again later.',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
        }).then(() => {
          setOpenServiceDialog(true);
        });
      }

    } catch (error) {
      setloading(false);

      console.error('Error submitting comments:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Please try again later.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then(() => {
        setOpenServiceDialog(true);
      });
    }
  };
  
  
  
const createInvoiceImageProps = (image, setImage, allImages) => ({
        onRemove: (file) => {
          const newFileList = image.filter(item => item.uid !== file.uid);
          setImage(newFileList);
        },
        beforeUpload: (file) => {
          const isAcceptedFileType = acceptedFileTypes.includes(file.type);
          if (!isAcceptedFileType) {
            message.error('You can only upload JPEG and PNG image files!');
            return false;
          }
 
          const isDuplicate = allImages.some(img =>
            img.name === file.name &&
            img.size === file.size &&
            img.lastModified === file.lastModified
          );
 
          if (isDuplicate) {
            message.warning('This image has already been uploaded in another field.');
            return false;
          }
 
          setImage([file]); // only one allowed per field
          return false;
        },
        fileList: image,
    });


  const handleupdateservicestatusSubmit = async () => {
    try {
      setloading(true);

      const formData = new FormData();
      formData.append('login_id', login_id);
      formData.append('token_no', serviceDetails.tokenno);
      formData.append('call_status', selectedStatusId);
      formData.append('closure_comments', closureComments);
      formData.append('hpy_code', hpy_code);

      if (UploadInvImg.length > 0) {
        formData.append('uploaded_file', UploadInvImg[0]);
      }
	  
	  if(serialNoImage.length > 0){
        formData.append('serialNoImage', serialNoImage[0]);
      }
      if(motorComponentImage.length > 0) {
        formData.append('motorComponentImage', motorComponentImage[0]);
      }
      if(pumpComponentImage1.length > 0){
        formData.append('pumpComponentImage1', pumpComponentImage1[0]);
      }
      if(pumpComponentImage2.length > 0){
        formData.append('pumpComponentImage2', pumpComponentImage2[0]);
      }
	  
	  if(refferenceNumber){

        formData.append('refferenceNumber', refferenceNumber);

        if(dealerAndSubDealer){
          formData.append('dealerAndSubDealer', dealerAndSubDealer.code);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Warning',
            text: 'Please select Dealer and Sub Dealer.',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                swalContainer.style.zIndex = 99999; // make it appear on top of all modals
              }
            },
          });
          console.log('dealerAndSubDealer not selected',dealerAndSubDealer);
          setloading(false);
          return;
        }

      }

      if(outOfWarranty.d1 == "PAID SERVICE"){
        formData.append('outofwarranty', outOfWarrantycheck ? 1 : 0);
      }

      const response = await axios.post(BASE_URL + '/tollfreeupdateservicestatus', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const { success, message, code } = response.data;

      if (message) {
        setloading(false);

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: message,
          showConfirmButton: false,
          timer: 1500,
        });

        setOpenServiceDialog(false);
        ServiceLISTAPI();
        setComment('');
        setHappyCode('');
		setRefferenceNumber('');
      } else {
        setloading(false);

        setOpenServiceDialog(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: message || 'Please try again later.',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
        }).then(() => {
			setloading(false);
          setOpenServiceDialog(true);
        });
      }
    } catch (error) {
      console.error('Error submitting comments:', error);

      setOpenServiceDialog(false);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Please try again later.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then(() => {
		  setloading(false);
        setOpenServiceDialog(true);
      });
    }
  };



  const handleHappyCodeClick1 = async () => {
    try {
      setloading(true);

      // Make API request
      const response = await axios.post(BASE_URL + '/regenerateHappinessCode', {
        login_id: login_id,
        token_no: serviceDetails.tokenno,
      });

      const message = response.data.message;
      setloading(false);

      setSnackbarMessage(message);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);

      setComment('');

      setOpenServiceDialog(true); // Ensure this line is called only after everything is set

    } catch (error) {
      setloading(false);

      console.error('Error updating mechanic:', error);

      const errorMessage = error.response?.data?.message || 'Please try again later.';
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);

      setOpenServiceDialog(true);
    }
  };
  const toggleListVisibility = (listType) => {
    setActiveList(listType);
	setdashboardview(0);
	switch (listType) {
	 case 'Dashboard':
        setDashboard(true);
		setdashboardview(1);
        break;
      default:
        break;
    }				  
  };
  const openItemDialog = (item) => {
    setSelectedItem(item);
    switch (activeList) {
      case 'sales':
        setOpenSalesDialog(true);
        break;
      case 'service':
        setOpenServiceDialog(true);
        break;
      case 'completed':
        setOpenCompletedDialog(true);
        break;
		case 'Dashboard':
        setDashboard(true);
        break;		   
      default:
        break;
    }
  };
  const loadMoreItems = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 5);
  };

  const closeItemDialog = () => {
    setOpenSalesDialog(false);
    setOpenServiceDialog(false);
    setOpenCompletedDialog(false);
	 setDashboard(false);					
    setCallStatusComment("");
    setIsEditing(false);
    setIsEditing1(false);
    setComment("");
    setClosureComments("");
	setPumpmotorimage(false);
  };

  const getActiveListItems = () => {
    switch (activeList) {
      case 'sales':
        return salesList;
      case 'service':
        return serviceList;
	case 'Dashboard':
        return dashboardList;			   
      case 'completed':
       
      default:
        return [];
    }
  };

  const getCardBackgroundColor = (c_date) => {
    const currentDate = new Date();
    const createdDate = new Date(c_date);
    const diffInHours = (currentDate - createdDate) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return 'White';
    } else if (diffInHours < 48) {
      // return '#F9BFBF';
      return '#ff822e';
    } else {
      return '#FF8282';
    }
  };

  const getCardColor = (c_date) => {
    const currentDate = new Date();
    const createdDate = new Date(c_date);
    const diffInHours = (currentDate - createdDate) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return 'black';
    } else if (diffInHours < 48) {
      return 'black';
    } else {
      return 'white';
    }
  }; 

	const RadioFillterChange = async (e) =>{
		setRadioValue(e.target.value);

		try {
		  setloading1(true);
		  const response = await axios.post(BASE_URL + '/tollfreependingservice', {
			login_id: login_id,
			RadioValue: e.target.value,
			linecount: 'ALL'
		  });
		  setserviceList(response.data.tollfreependingservicelist);
		  setloading1(false);
		} catch (error) {
		  setloading1(false);
		  console.error('Error fetching data:', error);
		}
		
	}; 

	const SerachFillterChange = async (e) =>{
		setSearchInput(e.target.value);

		if(e.target.value.length > 3){
			try {
			  setloading1(true);
			  const response = await axios.post(BASE_URL + '/tollfreependingservice', {
				login_id: login_id,
				SearchInput: e.target.value,
				linecount: 'ALL'
			  });
			  setserviceList(response.data.tollfreependingservicelist);
			  setloading1(false);
			} catch (error) {
			  setloading1(false);
			  console.error('Error fetching data:', error);
			}
		}
		
	};
	
	const FieldPartnerFillterChange = async (e) => {
		setFieldPartnerValue(e.target.value);
		 setserviceList([]);
		try {
		  setloading1(true);
		  const response = await axios.post(BASE_URL + '/tollfreependingservice', {
			login_id: login_id,
			FieldPartner: e.target.value,
			linecount: 'ALL'
		  });
		  if(response.data.tollfreependingservicelist.length > 0){			  
			  setserviceList(response.data.tollfreependingservicelist);
		  }
		  setloading1(false);
		} catch (error) {
		  setloading1(false);
		  console.error('Error fetching data:', error);
		}
	}
	
	const ResetFilterBtnClick = () => {
		setFieldPartnerValue(null);
		setSearchInput(null);
		setRadioValue(null);
		
		ServiceLISTAPI();
	};
				// ServiceLISTAPI();
  

  const items = getActiveListItems(); // Call the function to get the list items 
  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      <Box sx={{
        display: 'flex',
        overflowX: 'auto',
        padding: 2,
        color: '#fff',
        '&::-webkit-scrollbar': {
          height: '10px',
          backgroundColor: '#fff',  // Color of the scrollbar track
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#fff',  // Color of the scrollbar thumb
          borderRadius: '5px',
        },
      }}>
	  <Box sx={{ flex: '0 0 auto', width: { xs: '80%', sm: 'auto' }, marginRight: 2 }}>
          <Button
            onClick={() => toggleListVisibility('Dashboard')}
            sx={{ textDecoration: 'none', color: 'inherit', width: '100%', height: '100%' }}
          >
            <Card
              sx={{
                backgroundColor: 'darkseagreen',
                height: '100%',
                '&:hover': {
                  backgroundColor: 'darkseagreen',
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out'
                }
              }}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', height: 80 }}>
                <Badge badgeContent={dashboardList.length} color="error" sx={{ marginRight: 2 }}>
                  <DashboardIcon sx={{ fontSize: 50 }} />
                </Badge>
                <Typography variant="h5" component="div">
                  View Dashboard
                </Typography>
              </CardContent>
            </Card>
          </Button>
        </Box>
        <Box sx={{ flex: '0 0 auto', width: { xs: '80%', sm: 'auto' }, marginRight: 2, justifyContent: 'center' }}>
          <Button
            onClick={() => toggleListVisibility('sales')}
            sx={{ textDecoration: 'none', color: 'inherit', width: '100%', height: '100%' }}
          >
            <Card
              sx={{
                backgroundColor: '#ffcc80',
                height: '100%',
                '&:hover': {
                  backgroundColor: '#ffb74d',
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out'
                }
              }}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', height: 80 }}>
                <Badge badgeContent={salesList.length} color="error" sx={{ marginRight: 2 }}>
                  <Assignment sx={{ fontSize: 50 }} />
                </Badge>
                <Typography variant="h5" component="div">
                  Sales Enquiry
                </Typography>
              </CardContent>
            </Card>
          </Button>
        </Box>
        <Box sx={{ flex: '0 0 auto', width: { xs: '80%', sm: 'auto' }, marginRight: 2 }}>
          <Button
            onClick={() => toggleListVisibility('service')}
            sx={{ textDecoration: 'none', color: 'inherit', width: '100%', height: '100%' }}
          >
            <Card
              sx={{
                backgroundColor: '#80cbc4',
                height: '100%',
                '&:hover': {
                  backgroundColor: '#4db6ac',
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out'
                }
              }}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', height: 80 }}>
                <Badge badgeContent={serviceList.length} color="error" sx={{ marginRight: 2 }}>
                  <Build sx={{ fontSize: 50 }} />
                </Badge>
                <Typography variant="h5" component="div">
                  Service Enquiry
                </Typography>
              </CardContent>
            </Card>
          </Button>
        </Box>
		
        <Box sx={{ flex: '0 0 auto', width: { xs: '80%', sm: 'auto' }, marginRight: 2 }}>
          <Button
            onClick={() => toggleListVisibility('TokenNoView')}
            sx={{ textDecoration: 'none', color: 'inherit', width: '100%', height: '100%' }}
          >
            <Card
              sx={{
                backgroundColor: '#dbce18',
                height: '100%',
                '&:hover': {
                  backgroundColor: '#ebdc0c',
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out'
                }
              }}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', height: 80 }}>
				<Search sx={{ fontSize: 50 }} />
                <Typography variant="h5" component="div">
                  Token No Lookup
                </Typography>
              </CardContent>
            </Card>
          </Button>
        </Box>
      </Box>
	  
	  {activeList === 'TokenNoView' && (
		<>
			<div className="m-3">
				<div className="text-center mb-4">
					<h3><u>Token Number Details</u></h3>
				</div>

				<div className="row g-3 align-items-center">
					<div className="col-md-8">
						<Input
							size="large"
							placeholder="Enter your token number"
							prefix={<DocumentScannerIcon sx={{ color: "#1677ff" }} />}
							value={InputTokenNo}
							onChange={(e) => setInputTokenNo(e.target.value)}
							style={{ borderRadius: '8px' }}
						/>
					</div>
					<div className="col-md-4">
						<Btn
							type="primary"
							icon={<SearchIcon />}
							size="large"
							block
							onClick={ViewBtnClick}
							style={{ borderRadius: '8px' }}
						>
							Search
						</Btn>
					</div>
				</div>

				{TokenDetails && Object.values(TokenDetails).some(value => value) && (
					<Paper
						elevation={3}
						sx={{
							p: 3,
							mt: 5,
							borderRadius: 4,
							background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
							boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
							transition: 'transform 0.3s ease, box-shadow 0.3s ease',
							'&:hover': {
								transform: 'translateY(-2px)',
								boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
							},
						}}
					>
						<Typography variant="h5" align="center" sx={{ fontWeight: 700, color: '#1976d2' }}>
							{TokenType} Token Details
						</Typography>

						<Divider sx={{ my: 2, borderColor: '#90caf9' }}>
							<Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 400, display: 'flex', alignItems: 'center' }}>
								<InfoIcon fontSize="medium" sx={{ mr: 1 }} />
								Call Details
							</Typography>
						</Divider>

						<Grid container spacing={2}>
							{[
								['Token No:', TokenDetails.tokenno || '-'],
								['Serial No / Warranty:', `${TokenDetails.serialno || '-'} / ${TokenDetails.warranty || '-'}`],
								['Item Description / Segment:', `${TokenDetails.itemdesc || '-'} / ${TokenDetails.segment || '-'}`],
								['Toll-Free Comments:', TokenDetails.complaints || '-'],
								['Customer Comments:', TokenDetails.cust_comment || '-'],
								['Branch Name:', TokenDetails.branch_name || '-'],
								['Service Center Name:', TokenDetails.dealername || '-'],
								['Service Center Code:', TokenDetails.service_center_code || '-'],
								['Call Status:', TokenDetails.status || '-'],
				                ['Call Remarks:', TokenDetails.call_remarks || '-'],
				                ['Call Closed By:', TokenDetails.call_closed_by || '-'],
				                ['Call Closed Date:', TokenDetails.call_closed_on || '-'],
							].map(([label, value], idx) => (
								<Grid item xs={12} sm={6} key={idx}>
									<Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#4e342e' }}>
										{label}
									</Typography>
									<Typography variant="body1" sx={{ color: '#1b5e20' }}>
										<b style={{ fontSize: '14px' }}>{value || '-'}</b>
									</Typography>
								</Grid>
							))}
						</Grid>

						<Divider sx={{ my: 2, borderColor: '#90caf9' }}>
							<Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 400, display: 'flex', alignItems: 'center' }}>
								<InfoIcon fontSize="medium" sx={{ mr: 1 }} />
								Customer Details
							</Typography>
						</Divider>

						<Grid container spacing={2}>
							{[
								['Customer ID:', TokenDetails.custid || '-'],
								['Name:', TokenDetails.name || '-'],
								['Pincode:', TokenDetails.pincode || '-'],
								['Mobile:', TokenDetails.mobileno || '-'],
								['Address:', TokenDetails.place || '-'],
								['Area:', TokenDetails.AREA_NAME || '-'],
								['District:', TokenDetails.DISTRICT_DESC || '-'],
								['State:', TokenDetails.state || '-'],
							].map(([label, value], idx) => (
								<Grid item xs={12} sm={6} key={idx}>
									<Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#4e342e' }}>
										{label}
									</Typography>
									<Typography variant="body1" sx={{ color: '#1b5e20' }}>
										<b style={{ fontSize: '14px' }}>{value || '-'}</b>
									</Typography>
								</Grid>
							))}
						</Grid>
					</Paper>
				)}
			</div>
		</>
	  )}

      {activeList === 'sales' ? (
        <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
          <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography variant="h5">
              Sales Enquiry
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#999' }}>

        </Typography>
      )}

      {activeList === 'service' ? (
		<>
			<Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
			  <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
				<Typography variant="h5">
					Service Enquiry
				</Typography>
			  </CardContent>
			</Card>
			<div className="row mt-3">
				<div className="col-md-12 mt-1">
					<TextField
						label="🔍 Enter Token No, Serial No, or Comments" 
						variant="outlined" 
						fullWidth
						size="small"
						value={SearchInput}
						onChange={SerachFillterChange}
					/>
				</div>
				<div className="col-md-6 mt-2">
					<div
					  className=""
					  style={{
						padding: '10px 16px',
						border: '1px solid #ddd',
						borderRadius: '8px',
						marginBottom: '16px',
					  }}
					>
					  <label style={{ fontWeight: 'bold', marginRight: '8px' }}>
						Hour Base Filter:
					  </label>
					  &nbsp;
					  <Radio.Group onChange={RadioFillterChange} value={RadioValue}>
						<div
						  style={{
							display: 'flex',
							gap: '12px',
							flexWrap: 'wrap',
							alignItems: 'center',
						  }}
						>
						  <Radio value={24}>0 To 24</Radio>
						  <Radio value={48}>24 To 48</Radio>
						  <Radio value={0}>48 Above</Radio>
						</div>
					  </Radio.Group>
					</div>
				</div>
				<div className="col-md-6 mt-2">
					<div
					  className=""
					  style={{
						padding: '10px 16px',
						border: '1px solid #ddd',
						borderRadius: '8px',
						marginBottom: '16px',
					  }}
					>
					  <label style={{ fontWeight: 'bold', marginRight: '8px' }}>
						Field Patrner Filter:
					  </label>
					  &nbsp;
					  <Radio.Group onChange={FieldPartnerFillterChange} value={FieldPartnerValue}>
						<div
						  style={{
							display: 'flex',
							gap: '12px',
							flexWrap: 'wrap',
							alignItems: 'center',
						  }}
						>
						  <Radio value={"Assigned"}>Assigned</Radio>
						  <Radio value={"Not_Assigned"}>Not Assigned</Radio>
						</div>
					  </Radio.Group>
					</div>
				</div>
				<div className="col-md-12 mt-1">
					<Button 
						variant="contained"
						onClick={ResetFilterBtnClick}
						fullWidth
					>
						Reset Filter
					</Button>
				</div>
			</div>
			<hr/>
		</>
      ) : (
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#999' }}>

        </Typography>
      )}
	  
      {activeList === 'completed' ? (
        <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
          <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography variant="h5">
              completed Enquiry
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#999' }}>

        </Typography>
      )}
	  
   {activeList === 'Dashboard' ? (
        <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
          <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography variant="h5">
              Dashboard
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#999' }}>

        </Typography>
      )}
	  
	  {dashboardview == 1 && (
	  <div>
	  <br/>
	  <div className="row">
	<div className="col-sm-6">
	<PicChartCalls />
	</div>
	<div className="col-sm-6">
	<Service_Bar_Chart />
	</div>
	<div className="col-sm-6">
	<SalesPicChartCalls />
	</div>
	<div className="col-sm-6">
	  <Service_Bar_Chart_New />
	</div>
	</div>
	  </div>
	  )}

      <div className="navbar-container" style={{
        ...styles.navbarContainer,
        ...(isXsScreen && styles.navbarContainerXs), // Apply XS styles if isXsScreen is true
      }}>
        {items.slice(0, visibleItems).map((item, index) => ( // Adjust the number of visible items as needed
          <ListItem
            key={index}
            button
            onClick={() => handleListItemClick(item.tokenno)} // Pass token number on list item click
            style={styles.listItem}
          >
             <Card
            key={item.tokenno}
            style={{
              width: '100%',
              borderRadius: 2,
              backgroundColor: getCardBackgroundColor(item.c_date),
              color : getCardColor(item.c_date),
            }}
          >
            {/* <Card style={{ width: '100%', borderRadius: 2,backgroundColor:'red' }}> */}
              <CardContent style={{ position: 'relative' }}>
                <Box
                  style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    width: 'auto',
                    height: '18px',
                    backgroundColor: '#FFA500',
                    padding: '4px',
                    borderRadius: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    textAlign: 'right',
                    color: '#fff',
                  }}
                >
                  {activeList === 'service' ? (
                    <Typography variant="body2" style={{ fontWeight: 'bold', color: 'green' }}>
                      Serial: {item.serialno}
                    </Typography>
                  ) : (
                    <>
                      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                        HP: {item.hp}
                      </Typography>
                      /
                      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                        App: {item.application}
                      </Typography>
                    </>
                  )}
                </Box>
                <Typography variant="h6" component="div" style={{ fontWeight: 'bold',  color : getCardColor(item.c_date) }}>
                  Token#: {item.tokenno}
                </Typography>
                {activeList === 'service' ? (
                  <Typography variant="body2" style={{ fontWeight: 'bold',  color : getCardColor(item.c_date) }}>

                  </Typography>
                ) : (
                  <Typography variant="body2" style={{ fontWeight: 'bold',  color : getCardColor(item.c_date) }}>
                    Product: {item.product}
                  </Typography>
                )}
                <Typography variant="body2" style={{ fontWeight: 'bold',  color : getCardColor(item.c_date) }}>
                  Comments: {item.comment} {item.complaints}
                </Typography>
              </CardContent>
            </Card>
          </ListItem>
        ))}



        {/* Load More button */}
        {visibleItems < items.length && (
          <Button variant="contained" color="success" onClick={loadMoreItems} style={{ margin: '8px', height: '36px' }}>
            Load More
          </Button>
        )}
      </div>
      {/* Separate Dialogs for each list */}
      <Dialog open={openSalesDialog} onClose={closeItemDialog} maxWidth="lg" fullWidth>
        <DialogActions>
          <div style={{ marginTop: '10px', display: 'right', gap: '10px' }}>

            <Button variant="contained" onClick={closeItemDialog} endIcon={<CloseIcon />} color="error">

            </Button>
          </div>
        </DialogActions>
        {selectedItem && (
          <>
            <DialogTitle align='center'>
              <Typography variant="h4" style={{

                backgroundColor: '#03A9F4', 
                padding: '10px 20px',       
                borderRadius: '8px',      
                color: '#fff',            
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)', 

              }}>
                Sales Enquiry
              </Typography>
            </DialogTitle>
            <DialogContent>
              <center>
                <Typography variant="h6" style={{

                  backgroundColor: '#03A9F4', 
                  width: '50%',
                  borderRadius: '8px',        
                  color: '#fff',             
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}>
                  Call Details
                </Typography>
              </center>
              <br></br>
              <div className='row'>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Token#" variant="outlined"
                    value={selectedItem.tokenno} sx={{ width: '100%' }}
                    InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="HP" variant="outlined" value={selectedItem.hp} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="App" variant="outlined" value={selectedItem.application} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Product" variant="outlined" value={selectedItem.product} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Toll-Free Comments" variant="outlined" value={selectedItem.comment} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Customer Comments" variant="outlined" value={selectedItem.cust_comment} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <center>
                  <Typography variant="h6" style={{

                    backgroundColor: '#03A9F4', // Light gray background color
                    width: '50%',
                    borderRadius: '8px',        // Rounded corners for the background
                    color: '#fff',              // Dark text color for contrast
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)' // Subtle shadow for depth
                  }}>
                    Customer Details
                  </Typography>
                  <br></br>
                </center>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Customer#" variant="outlined" value={selectedItem.custid} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Name" variant="outlined" sx={{ width: '100%' }} value={selectedItem.name} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Pincode" variant="outlined" value={selectedItem.pincode} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Mobile#" variant="outlined" value={selectedItem.mobileno} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-4 mb-3'>
                  <TextField size="small" fullWidth label="Address" variant="outlined" value={selectedItem.address} sx={{ width: '100%' }} InputLabelProps={{ style: { color: '#337ab7' } }} />
                </div>
                <div className='col-md-12 mb-3'>
                  <TextField
                    size="small"
                    fullWidth
                    label="Call Status"
                    variant="outlined"
                    select
                    SelectProps={{ native: true }}
                    value={callStatus}
                    onChange={handleCallStatusChangeSales}
                    sx={{ width: '100%' }}
                  >
                    {[
                      "",
                      "BOUGHT FROM CRI",
                      "BOUGHT FROM OTHER COMPANY",
                      "CUSTOMER WILL BUY LATER",
                      "NO RESPONSE FROM DEALER",
                      "NUMBER NOT REACHABLE",
                      "PERSON NOT INTERESTED",
                      "RINGING NO RESPONSE",
                      "SWITCH OFF",
                      "WRONG NUMBER"
                    ].map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </TextField>
                  {callStatus === "BOUGHT FROM CRI" && (
                    <div className='mt-3'>
                      <div className='row'>
                        <div className='col-md-4 mb-3'>
                          <TextField size="small" fullWidth
                            label="Product Value" variant="outlined" sx={{ width: '100%' }}
                            value={productValue}
                            onChange={(e) => setProductValue(e.target.value)} />
                        </div>
                        <div className='col-md-4 mb-3'>
                          <TextField size="small" fullWidth label="Item Name" variant="outlined"
                            value={itemName}
                            onChange={(e) => setItemName(e.target.value)} sx={{ width: '100%' }} />
                        </div>
                        <div className='col-md-4 mb-3'>
                          <TextField size="small" fullWidth label="Serial No" variant="outlined"
                            value={serialNo}
                            onChange={(e) => setSerialNo(e.target.value)} sx={{ width: '100%' }} />
                        </div>
                      </div>
                      <div style={{ marginTop: '10px' }}>
                        <Button variant="contained" color="success" onClick={handleButtonClick} disabled={!isFormValid()} >
                          Product Register
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
                <div className='col-md-12'>
                  <TextField
                    size="small"
                    fullWidth
                    label="Call Status Comments:"
                    variant="outlined"
                    value={closureComments}
                    onChange={handleClosureCommentsChange}
                    multiline
                    rows={3}
                    sx={{ width: '100%' }}
                  />
                </div>
                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                  <Button variant="contained" color="warning" onClick={handleStatusSubmit} sx={{ borderRadius: '8px' }} endIcon={<PublishedWithChangesIcon />} >
                    Change Status
                  </Button>
                </div>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', marginBottom: '16px' }}>
                  <TextField
                    size="small"
                    fullWidth
                    label="Enter Your Comments:"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={comment}
                    onChange={handleChangeComment}
                    sx={{ flexGrow: 1, marginRight: '8px', borderRadius: '8px' }}
                    InputProps={{
                      sx: {
                        borderRadius: '28px',
                      }
                    }}
                  />
                  <Button
                    variant="contained"
                    color="success"
                    endIcon={<SendIcon />}
                    onClick={handleSubmit}
                    sx={{ borderRadius: '8px' }}
                  >
                    Send
                  </Button>
                </Box>
              </div>
              <div>
                {CommentDatasales.map((comment, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginBottom: '8px',
                      justifyContent: comment.dealer_code === USER_ID ? 'flex-end' : 'flex-start'
                    }}
                  >
                    {comment.dealer_code !== USER_ID && (
                      <div
                        style={{
                          marginRight: '12px',
                          width: '48px',
                          height: '48px'
                        }}
                      >
                        <Avatar alt="Avatar" style={{ width: '48px', height: '48px' }} />
                      </div>
                    )}
                    <div
                      style={{
                        backgroundColor: comment.dealer_code === USER_ID ? '#d9fdd3' : '#DCDCDC', // WhatsApp green color
                        borderRadius: '18px',
                        borderTopLeftRadius: comment.dealer_code === USER_ID ? '18px' : '0',
                        borderBottomLeftRadius: '18px',
                        borderTopRightRadius: comment.dealer_code === USER_ID ? '0' : '18px',
                        borderBottomRightRadius: comment.dealer_code === USER_ID ? '18px' : '18px',
                        width: 'auto',
                        maxWidth: '80%',
                        padding: '12px',
                        boxSizing: 'border-box',
                        position: 'relative'
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          color: 'blue',
                          marginBottom: '4px'
                        }}
                      >
                        {comment.custid_or_dealer_code} / {comment.dealer_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: 'black'
                        }}
                      >
                        {comment.comment}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: 'grey',
                          marginTop: '4px',
                          textAlign: 'right'
                        }}
                      >
                        {formatDistanceToNow(new Date(comment.c_date), { addSuffix: true })}
                      </Typography>
                      <div
                        style={{
                          position: 'absolute',
                          top: '0px',
                          left: comment.dealer_code === USER_ID ? 'auto' : '-16px',
                          right: comment.dealer_code === USER_ID ? '-16px' : 'auto',
                          width: '0',
                          height: '0',
                          borderTop: '0px solid transparent',
                          borderBottom: '11px solid transparent',
                          borderLeft: comment.dealer_code === USER_ID ? '17px solid #d9fdd3' : '0',
                          borderRight: comment.dealer_code !== USER_ID ? '17px solid #DCDCDC' : '0'
                        }}
                      />
                    </div>
                    {comment.dealer_code === USER_ID && (
                      <></>
                    )}
                  </div>
                ))}
              </div>
            </DialogContent> </>
        )}
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <Dialog open={openServiceDialog} onClose={closeItemDialog} maxWidth="lg" fullWidth>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={1500}
          onClose={handleSnackbarClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            <AlertTitle>{snackbarSeverity === 'success' ? 'Success' : 'Error'}</AlertTitle>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <DialogActions>
          <div style={{ marginTop: '10px', display: 'right', gap: '10px' }}>

            <Button variant="contained" onClick={closeItemDialog} endIcon={<CloseIcon />} color="error">

            </Button>
          </div>
        </DialogActions>
        <DialogTitle align='center'>
          <Typography
            variant="h4"
            style={{

              backgroundColor: '#03A9F4', // Light gray background color
              padding: '10px 20px',       // Add some padding around the text
              borderRadius: '8px',        // Rounded corners for the background
              color: '#333',              // Dark text color for contrast
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)' // Subtle shadow for depth
            }}
          >
            Service Enquiry
          </Typography>
        </DialogTitle>
        <DialogContent>
          <center>
            <Typography variant="h6" style={{

              backgroundColor: '#03A9F4', // Light gray background color
              width: '50%',
              borderRadius: '8px',        // Rounded corners for the background
              color: '#333',              // Dark text color for contrast
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)' // Subtle shadow for depth
            }}>
              Call Details
            </Typography>
          </center>
          <br></br>
          <div className='row'>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Token" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%' }} value={serviceDetails.tokenno || ''} />
            </div>
            <Box className='col-md-4 mb-3'>
              <TextField
                size="small"
                fullWidth
                label="Serial"
                variant="outlined"
                value={serviceDetails.serialno}
                InputLabelProps={{ style: { color: '#337ab7' } }}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {!isEditing ? (
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleEditClick}
                          startIcon={<EditIcon />}
                        >

                        </Button>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={handleUpdateClick}
                            startIcon={<CheckIcon />}
                            sx={{ ml: 1, width: '60px' }}
                          >

                          </Button>
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={handleCancelClick}
                            startIcon={<CancelIcon />}
                            sx={{ ml: 1, width: '60px' }}
                          >

                          </Button>
                        </>
                      )}
                    </InputAdornment>
                  ),
                  readOnly: !isEditing, // Make field read-only if not editing
                }}
              />
            </Box>
            <div className='col-md-4 mb-3'>
              <TextField size="small" InputLabelProps={{ style: { color: '#337ab7' } }} fullWidth label="Warranty" variant="outlined" sx={{ width: '100%' }} value={serviceDetails.warranty || ''} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Item Description / Segment" InputLabelProps={{ style: { color: '#337ab7' } }} variant="outlined" sx={{ width: '100%' }} value={`${serviceDetails.itemdesc || ''} / ${serviceDetails.segment || ''}`} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Toll-Free Comments" InputLabelProps={{ style: { color: '#337ab7' } }} variant="outlined" sx={{ width: '100%' }} value={serviceDetails.complaints || ''} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Customer Comments" InputLabelProps={{ style: { color: '#337ab7' } }} variant="outlined" sx={{ width: '100%' }} value={serviceDetails.cust_comment || ''} />
            </div>
            <center>
              <Typography variant="h6"
                style={{

                  backgroundColor: '#03A9F4', // Light gray background color
                  width: '50%',
                  borderRadius: '8px',        // Rounded corners for the background
                  color: '#333',              // Dark text color for contrast
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)' // Subtle shadow for depth
                }}
              >
                Customer Details
              </Typography>
              <br></br>
            </center>



            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Customer" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%' }} value={serviceDetails.custid || ''} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Name" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%' }} value={customerDetails.name || ''} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Pincode" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%' }} value={customerDetails.pincode || ''} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Mobile" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%' }} value={customerDetails.mobileno || ''} />
            </div>
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Address" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%' }} value={customerDetails.c_address || ''} />
            </div>
            <Box className="col-md-4 mb-3">
              {!isEditing1 ? (
                <>
                  <TextField
                    size="small"
                    fullWidth
                    label="Current Assigned Mechanic"
                    variant="outlined"
                    InputLabelProps={{ style: { color: '#337ab7' } }}
                    value={currentMechanic}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleEditClick1}
                    sx={{ mt: 2 }}
                  >
                    Edit
                  </Button>
                </>
              ) : (
                <>
                  <TextField
                    size="small"
                    fullWidth
                    label="Select Mechanic"
                    variant="outlined"
                    select
                    value={selectedMechanic}
                    onChange={(e) => setSelectedMechanic(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Button
                            variant="outlined"
                            color="success"
                            startIcon={<CheckIcon />}
                            onClick={handleUpdateClick1}
                            sx={{ ml: 1, width: '60px' }}
                          />
                          <Button
                            variant="outlined"
                            color="error"
                            startIcon={<CancelIcon />}
                            onClick={handleCancelClick1}
                            sx={{ ml: 1, width: '60px' }}
                          />
                        </Box>
                      ),
                    }}
                  >
                    {mechanicList.map((mechanic) => (
                      <MenuItem key={mechanic.ID} value={mechanic.mech_name}>
                        {mechanic.mech_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              )}
            </Box>
			
			{
        refferedReplascement && (
               <>
                <div className='col-md-4 mb-3'>
                    <TextField size="small" fullWidth label="REFERENCE NUMBER" variant="outlined" InputLabelProps={{ style: { color: '#337ab7' } }} sx={{ width: '100%'}} value={refferenceNumber} />
                </div>

                 <div className='col-md-4 mb-3'>
                    <Stack direction="row" alignItems="center">
                      <Grid container>
                        <Grid item xs={11}>
                          <Typeahead
                            id="dealerAndSubDealer"
                            labelKey={(option) => `${option.code} - ${option.name}`}
                            options={dealerAndSubDealerList}
                            placeholder="Select Dealer and SubDealer"
                            selected={dealerAndSubDealer ? [dealerAndSubDealer] : []}
                            onChange={(selected) => setDealerAndSubDealer(selected[0] || null)}
                            highlightOnlyResult
                            minLength={0}
                            onFocus={(e) => e.target.click()}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <button
                            type="button"
                            onClick={reloadeDealerAndSubDealerList}
                            style={{
                              backgroundColor: "blue",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              width: "100%",
                              height: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <TfiReload size={15} />
                          </button>
                        </Grid>
                      </Grid>
                    </Stack>
                </div>
                 <div className='col-md-4 mb-3'>
                       <Stack direction="row" >
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            placeholder="Area, District, State Or Pincode"
                            value={dealerAndSubDealerSearchList}
                            onChange={handle_area_district_state_pincode_change()}
                          />
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleSearch}
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Search
                          </Button>
                        </Stack>
                 </div>
</>
             )
        }

            {
               outOfWarranty.d1 == "PAID SERVICE" &&(
                <div className='col-md-4 mb-3'>
                  <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={outOfWarrantycheck}
                          onChange={(e) => setOutOfWarrantycheck(e.target.checked)}
                          sx={{
                            color: "#337ab7",
                            "&.Mui-checked": {
                              color: "#337ab7",
                            },
                          }}
                        />
                      }
                      label="Out Of Warranty"
                    />
                </div>
               )
            }
			
            <div className='col-md-4 mb-3'>
              <Upload {...InvoiceImage} maxCount={1}>
                <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Upload your file</Btn>
              </Upload>
            </div>
			
			
			 { pumpmotorimage && (
                   <div className="row">
                      <div className='col-md-3 mb-3'>
                          <Upload {...createInvoiceImageProps(serialNoImage, setSerialNoImage, [...motorComponentImage, ...pumpComponentImage1, ...pumpComponentImage2])} maxCount={1}>
                            <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Serial No Image</Btn>
                          </Upload>
                          {serialNoImage.length > 0 && (
                            <div style={{ width: '200px', height: '200px' }}>
                               <img src={URL.createObjectURL(serialNoImage[0])} alt="Serial No" style={{ width: '100%', height: '100%', objectFit: 'cover', marginTop: '10px' }} />
                            </div>
                           )}
                        </div>
                        <div className='col-md-3 mb-3'>
                          <Upload {...createInvoiceImageProps(motorComponentImage, setMotorComponentImage, [...serialNoImage, ...pumpComponentImage1, ...pumpComponentImage2])} maxCount={1}>
                            <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Motor Component Image</Btn>
                          </Upload>
                          {motorComponentImage.length > 0 && (
                            <div style={{ width: '200px', height: '200px' }}>
                                <img src={URL.createObjectURL(motorComponentImage[0])} alt="Motor Component" style={{ width: '100%', height: '100%', objectFit: 'cover', marginTop: '10px' }} />
                              </div>    
                            )}
                        </div>
                        <div className='col-md-3 mb-3'>
                          <Upload {...createInvoiceImageProps(pumpComponentImage1, setPumpComponentImage1, [...serialNoImage, ...motorComponentImage, ...pumpComponentImage2])} maxCount={1}>

                            <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Pump Component Image1</Btn>
                          </Upload>
                          {pumpComponentImage1.length > 0 && (
                            <div style={{ width: '200px', height: '200px' }}>
                                <img src={URL.createObjectURL(pumpComponentImage1[0])} alt="Pump Component 1" style={{ width: '100%', height: '100%', objectFit: 'cover', marginTop: '10px' }} />
                            </div>
                          )}
                        </div>

                        <div className='col-md-3 mb-3'>
                          <Upload {...createInvoiceImageProps(pumpComponentImage2, setPumpComponentImage2, [...serialNoImage, ...motorComponentImage, ...pumpComponentImage1])} maxCount={1}>
                             <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Pump Component Image2</Btn>
                          </Upload>
                            {pumpComponentImage2.length > 0 && (
                              <div style={{ width: '200px', height: '200px' }}>
                                <img src={URL.createObjectURL(pumpComponentImage2[0])} alt="Pump Component 2" style={{ width: '100%', marginTop: '10px',height: '100%', objectFit: 'cover', }} />
                              </div>
                            )}
                        </div>
                  </div>
            )}
			
			
            <div className='col-md-12 mb-3'>
              <TextField
                size="small"
                fullWidth
                label="Call Status Comments"
                variant="outlined"
                select
                SelectProps={{ native: true }}
                value={callStatusComment}
                onChange={handleCallStatusChangeService}
                sx={{ width: '100%' }}
              >
                <option value=""></option>
                <option value="1">IN PROGRESS</option>
                {serviceStatusList.map((status) => (
                  <option key={status.id} value={status.remarks}>
                    {status.remarks}
                  </option>
                ))}
              </TextField>
              {showHappyCode && (
                <div className='mt-3'>
                  <div className='row'>
                    <div className='col-md-4 mb-3'>
                      <TextField
                        size="small"
                        fullWidth
                        label="Happy Code"
                        variant="outlined"
                        sx={{ width: '100%' }}
                        value={hpy_code} // Set the value of the TextField
                        onChange={handleChangehappy} // Handle changes to the TextField
                      />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <Button variant="contained" onClick={handleHappyCodeClick1} color="success">
                        Resend Happy Code
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-12'>
              <TextField
                size="small"
                fullWidth
                label="Call Status Comments:"
                variant="outlined"
                value={closureComments}
                onChange={handleClosureCommentsChange}
                multiline
                rows={3}
                sx={{ width: '100%' }}
              />
            </div>
            <div style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Button variant="contained" color="warning" onClick={handleupdateservicestatusSubmit} sx={{ borderRadius: '8px' }} endIcon={<PublishedWithChangesIcon />} >
                Change Status
              </Button>
            </div>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', marginBottom: '16px' }}>
              <TextField
                size="small"
                fullWidth
                label="Enter Your Comments:"
                variant="outlined"
                multiline
                rows={3}
                value={comment}
                onChange={handleChangeComment}
                sx={{ flexGrow: 1, marginRight: '8px', borderRadius: '8px' }}
                InputProps={{
                  sx: {
                    borderRadius: '28px',
                  }
                }}
              />
              <Button
                variant="contained"
                color="success"
                endIcon={<SendIcon />}
                onClick={handleServiceSubmit}
                sx={{ borderRadius: '8px' }}
              >
                Send
              </Button>
            </Box>
          </div>
          <div>
            {CommentDataservice.map((comment, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '8px',
                  justifyContent: comment.custid_or_dealer_code === USER_ID ? 'flex-end' : 'flex-start'
                }}
              >
                {comment.custid_or_dealer_code !== USER_ID && (
                  <div
                    style={{
                      marginRight: '12px',
                      width: '48px',
                      height: '48px'
                    }}
                  >
                    <Avatar alt="Avatar" style={{ width: '48px', height: '48px' }} />
                  </div>
                )}
                <div
                  style={{
                    backgroundColor: comment.custid_or_dealer_code === USER_ID ? '#d9fdd3' : '#DCDCDC', // WhatsApp green color
                    borderRadius: '18px',
                    borderTopLeftRadius: comment.custid_or_dealer_code === USER_ID ? '18px' : '0',
                    borderBottomLeftRadius: '18px',
                    borderTopRightRadius: comment.custid_or_dealer_code === USER_ID ? '0' : '18px',
                    borderBottomRightRadius: comment.custid_or_dealer_code === USER_ID ? '18px' : '18px',
                    width: 'auto',
                    maxWidth: '80%',
                    padding: '12px',
                    boxSizing: 'border-box',
                    position: 'relative'
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      color: 'blue',
                      marginBottom: '4px'
                    }}
                  >
                    {comment.custid_or_dealer_code} / {comment.dealer_name}
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      color: 'black'
                    }}
                  >
                    {comment.comment}
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      color: 'grey',
                      marginTop: '4px',
                      textAlign: 'right'
                    }}
                  >
                    {formatDistanceToNow(new Date(comment.c_date), { addSuffix: true })}
                  </Typography>
                  <div
                    style={{
                      position: 'absolute',
                      top: '0px',
                      left: comment.custid_or_dealer_code === USER_ID ? 'auto' : '-16px',
                      right: comment.custid_or_dealer_code === USER_ID ? '-16px' : 'auto',
                      width: '0',
                      height: '0',
                      borderTop: '0px solid transparent',
                      borderBottom: '11px solid transparent',
                      borderLeft: comment.custid_or_dealer_code === USER_ID ? '17px solid #d9fdd3' : '0',
                      borderRight: comment.custid_or_dealer_code !== USER_ID ? '17px solid #DCDCDC' : '0'
                    }}
                  />
                </div>
                {comment.custid_or_dealer_code === USER_ID && (
                  <></>
                )}
              </div>
            ))}
          </div>
        </DialogContent>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading1} >
        <CircularProgress color="inherit" />
      </Backdrop>

    </Box>
  );
};

export default StockView;
